<template>

  <LoadingDiv v-if="!isReady" />

  <div class="auth-enrollee-shell sba-slide-in" v-else>
    <div class="auth-enrollee-workbench" v-if="encounter">
      <div class="section auth-enrollee-section">
        <!-- <br /> -->
        <div class="card z-depth-0 auth-enrollee-card">
          <br />
          <span class="new badge left auth-scheme-badge" data-badge-caption="Scheme">{{
            encounter.scheme.name.toUpperCase()
          }}</span>

          <div class="card-content auth-enrollee-dossier">
            <div class="auth-enrollee-dossier-grid">
              <div class="auth-enrollee-identity">
                <p>{{ encounter.client_name }}</p>
                <h5>
                  {{ encounter.name }}
                  <sup><small><span class="black-text">{{
                    showAgeSex(encounter.dob, encounter.sex)
                        }}</span></small></sup>
                </h5>
                <h6>({{ encounter.enrollee_number }})</h6>
              </div>
              <div class="auth-enrollee-avatar">
                <img :src="encounter.profile_img" width="96" class="circle responsive-img right"
                  v-if="encounter.profile_img" />
                <img :src="`https://ui-avatars.com/api/?name=${encounter.name}&size=128`" width="96"
                  class="circle responsive-img right" v-else />
              </div>
            </div>
          </div>

          <!-- Entire Provider (diagnosis, claims) Display starts here -->
          <div class="card auth-provider-workflow">
            <!-- Provider Name -->
            <div class="card-content auth-provider-summary" v-if="'provider_id' in encounter">
              <div class="row spacerTop10">
                <div class="col s12">
                  <div class="spacer5">
                    <span class="card-title" v-if="selectedProvider && selectedProvider.name">{{ selectedProvider.name
                    }}

                      <a href="#" class="secondary-content orange-text right"><i class="material-icons teal lighten-4"
                          title="clear" @click.prevent="handleRestart">clear</i></a>
                    </span>

                    <h6 class="teal-text">
                      {{
                        new Date(serverDate).toLocaleString(
                          undefined,
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            weekday: 'long',
                          }
                        )
                      }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>

            <!-- Provider Form -->
            <div class="card-panel teal lighten-5 auth-provider-panel" v-if="!('provider_id' in encounter)">
              <div class="row">
                <div class="col s12">
                  <span class="card-title black-text">Provider</span>
                </div>
                <div class="col s12 m8">
                  <div class="input-field">
                    <FilterSimpleDiv inputId="filterProvider" fieldName="Select Provider" :data="filterProviderData"
                      :search="true" @selected="handlePick" @searching="handleSearch" />
                  </div>
                </div>
                <div class="col s12 m4">
                  <p>
                    <!-- Continue -->
                    <button class="waves-effect waves-light btn-large black col s12 m6 right" :class="{
                      disabled: isLoading || (!selectedProvider || (!siloMode && !selectedProvider.opid)),
                    }" @click="handleProvider()">
                      <i class="material-icons left" v-if="!isLoading">chevron_right</i>{{ isLoading ? "Going..." :
                        "Auth" }}
                    </button>
                    <!-- Complete -->
                    <button class="waves-effect waves-light btn-large modal-trigger col s12 m6 right" :class="{
                      disabled: isLoading || (!selectedProvider || (!siloMode && !selectedProvider.opid)),
                    }" data-target="confirmSubmitEncounterOnly">
                      <i class="material-icons left" v-if="!isLoading">send</i>{{ isLoading ? "Submitting..." :
                        "Send" }}
                    </button>
                  </p>

                </div>
                <div class="col s12">
                  <p class="chip red white-text"
                    v-if="!siloMode && (selectedProvider?.name && !selectedProvider?.opid)">
                    {{ selectedProvider?.name }} is unable to receive authorization.
                    Provider is in-active!
                  </p>
                </div>
              </div>
            </div>

            <!-- New -->
            <template v-else>
              <!-- Display Diagnosis -->
              <div class="row teal lighten-5 auth-diagnosis-row" v-if="diagnosisList.length">
                <div class="col s12">
                  <div class="card-content yellow lighten-1 auth-diagnosis-card">
                    <span class="black-text text-lighten-5">
                      <p>
                        <i class="material-icons black-text">bookmark_border</i>
                        Diagnosis: {{ diagnosisList.join(", ") }}
                        <a href="#" class="secondary-content edit-black-item right"><i class="material-icons" :class="{
                          'black-text': !resetDiagnosis,
                          'blue-text': resetDiagnosis,
                        }" title="edit diagnosis" @click.prevent="handleReviewDiagnosis">edit</i></a>
                      </p>
                    </span>
                  </div>
                </div>
              </div>

              <!-- Claims Display Card -->
              <div class="card auth-claims-card" v-if="claimsDisplayCard">
                <div class="card-content">
                  <span class="card-title">Item(s)</span>

                  <!-- List claims -->
                  <ol id="item-list" class="collection">
                    <li class="collection-item auth-line-item" v-for="claim in claims" :key="claim.id">
                      <span class="auth-line-copy">
                        <b>{{ claim.claim }}</b> x {{ claim.qty }} (₦{{
                          claim.amt
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }})
                      </span>

                      <span class="line-item-actions">
                        <a href="#" class="secondary-content cancel-item" @click.prevent="handleDelete(claim)"
                          title="delete"><i class="material-icons grey-text">cancel</i></a>

                        <a href="#" class="secondary-content edit-item" @click.prevent="handleEdit(claim)" title="edit"><i
                            class="material-icons" :class="{
                              'grey-text': editId != claim.id,
                              'blue-text': editId == claim.id,
                            }">edit</i></a>
                      </span>
                    </li>
                  </ol>

                  <!-- Claims Submit -->
                  <div v-if="claimsSubmitCard">
                    <!-- Total -->
                    <ul id="item-list" class="collection">
                      <li class="collection-item pull-right">
                        <b>Total</b> (Sent Amount):
                        <b><span class="red-text">₦{{ totalSent(claimsList) }}</span></b>
                      </li>
                    </ul>

                    <br />

                    <div v-if="error">
                      <p class="chip red white-text">
                        <br />
                        {{ error }}
                        <br />
                      </p>
                    </div>

                    <!-- Add -->
                    <button class="waves-effect waves-light btn-large black" :class="{ disabled: isSubmitting }"
                      @click.prevent="handleNext('moreClaims')"><i
                        class="medium material-icons left">add</i>Add</button>

                    <!-- Submit -->
                    <button class="waves-effect waves-light btn-large green right modal-trigger" :class="{
                      disabled: isSubmitting,
                    }" data-target="confirmSubmit"><i class="large material-icons right">check_circle</i>{{
                      isSubmitting ? "Authorizing ..." : "Authorize" }}
                    </button>

                  </div>
                </div>
              </div>

              <!-- Sumbmitting -->
              <div class="progress auth-submit-progress" v-if="isSubmitting">
                <div class="indeterminate"></div>
              </div>

              <!-- Add claim -->
              <AddClaim :turl="{ sid: encounter?.scheme_id, pid: encounter?.provider_id }" :type="type" :next="next"
                :editDiagnosis="resetDiagnosis" :claimItem="claim" @update="handleUpdate" @clear="handleClear"
                v-if="openAuth" />
            </template>

            <!-- History -->
            <div class="auth-history-shell">
              <HistoryAuth
                :enrolleeNumber="encounter.enrollee_number"
                :principal-id="encounter.principal_id"
                :scheme-id="encounter.scheme_id || encounter.scheme?.id"
                :hideUnFound="hideUnFound"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="auth-modal-host">
        <Modal id="confirmSubmitEncounterOnly" class="modal auth-confirm-modal" :title="alertTitle"
          :message="alertMessageEncounterOnly" @confirm="handleConfirmEncounterOnly" />
        <Modal id="confirmSubmit" class="modal auth-confirm-modal" :title="alertTitle" :message="alertMessage"
          @confirm="handleConfirm" />
      </div>

    </div>

    <div class="section center auth-no-encounter" v-if="!encounter">
      <h6>No Encounter Record for Enrollee <em>found</em>...</h6>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUpdated, computed, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ageSex } from "@/composables/fxLibrary/coreFx";
import { ABBR, OPID } from '@/laravel/config';
import getItems from "@/composables/getItems";
import postItemRemote from "@/composables/oneProvider/postItem";
import postItem from "@/composables/postItem";
import LoadingDiv from "@/components/LoadingDiv.vue";
import AddClaim from "@/components/claim/AddClaimComponent.vue";
import HistoryAuth from "@/components/auth/HistoryAuthComponent.vue";
import FilterSimpleDiv from "@/components/search/FilterSimpleDiv.vue";
import Modal from "@/components/alerts/ModalComponent.vue";
import { siloMode } from '@/laravel/config';
import M from "materialize-css";


export default {
  name: "EnrolleeAuthComponent",
  props: ["enrollee", "serverDate"],
  emits: ["restart"],
  components: { LoadingDiv, FilterSimpleDiv, AddClaim, HistoryAuth, Modal },
  setup(props, context) {
    const response = ref(null);
    const responseSearch = ref(null);
    const selectedItem = ref(null);
    const selectedProvider = ref(null);
    const isReady = ref(true);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const alertTitle = ref("Confirm");
    const alertMessage = ref("Are you sure you want to approve? Please confirm that all the details provided are accurate. Once submitted, changes cannot be made.");
    const alertMessageEncounterOnly = ref("You are registering enrollee encounter without authorization. Click confirm to proceed!");
    const error = ref(false);
    const editId = ref(null);
    const editClaim = ref(null);
    const deleteClaim = ref(null);
    const claimsDisplayCard = ref(false);
    const claimsSubmitCard = ref(false);
    const diagnosisList = ref([]);
    const resetDiagnosis = ref(false);
    const type = ref("auth"); // close claim after input
    const next = ref("next");
    const hideUnFound = ref(true);
    const claimsList = ref([]);
    const claim = ref(null);
    const openAuth = ref(true);
    const postResource = ref(null);
    const endPoint = ref(null);

    // router
    const router = useRouter();

    // store
    const store = useStore();

    // sort silo
    onMounted(() => {
      // sort
      if (!siloMode) {
        postResource.value = postItemRemote;
        endPoint.value = `remote/claim/encounter/bulk`;
      } else {
        postResource.value = postItem;
        endPoint.value = `claim/encounter/bulk`;
      }
    });

    // Provider
    const filterProviderData = computed(() => {
      // start
      let val = null;

      let valPlus;

      if (responseSearch.value) {
        if (responseSearch.value.key == "filterProvider") {
          valPlus = responseSearch.value.value.reduce((newArr, x) => {
            newArr[x.name] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // search function
    const getSearchItemsFromApi = (table, key) => {
      (async () => {
        const { res } = await getItems(table);
        if (res.value) {
          // search
          responseSearch.value = { key: key, value: res.value.data };
        }
      })();
    };

    // add up
    const totalSent = (claims) => {
      let total = 0;
      claims.forEach((x) => {
        total = Number(total) + Number(x.amt);
      });
      return total
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // ageSex
    const showAgeSex = (dob, sex) => {
      const { fx } = ageSex(dob, sex);
      return fx.value;
    };

    // starter
    onMounted(() => {
      // get started
      response.value = props.enrollee;
    });

    // alert
    onMounted(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {
        endingTop: "24%",
        startingTop: "18%",
      });
    });

    // alert
    onUpdated(() => {
      // modal
      const elems = document.querySelectorAll(".modal");
      M.Modal.init(elems, {
        endingTop: "24%",
        startingTop: "18%",
      });
    });

    // filter components where search is set to "true"
    const handleSearch = (val) => {
      if (val.id == "filterProvider") {
        // get new serach items
        getSearchItemsFromApi(`provider/filter?q=${val.value}`, val.id);
      }
    };

    // get option
    const handlePick = (val) => {
      selectedItem.value = val;
      // watchEffect will take over from here
    };

    // search watcher
    watchEffect(() => {
      // start
      if (selectedItem.value) {
        // sort
        if (selectedItem.value.id == "filterProvider") {
          //set
          if (!selectedItem.value.value) {
            selectedProvider.value = null;
          } else {
            responseSearch.value.value.forEach((x) => {
              if (x.name == selectedItem.value.value) {
                // found
                selectedProvider.value = { name: x.name, search: x.id, opid: x.opid };
              }
            });
          }
        }
      }
    });

    // scrollbar
    const resetScrollBar = () => {
      // Restore scrollbar (insurance)
      document.body.style.overflow = 'auto';
    };

    // handle provider
    const handleProvider = () => {
      // open auth
      openAuth.value = true; // insurance
      // Set provider
      response.value.provider_id = selectedProvider.value.search;
    };

    // handle Emitted update
    const handleUpdate = (val) => {
      claimsDisplayCard.value = val.claimsDisplayCard;
      claimsSubmitCard.value = val.claimsSubmitCard;
      claimsList.value = [...val.claimsList];
      diagnosisList.value = [...val.diagnosisList];
    };

    // handle edit
    const handleEdit = (val) => {
      claim.value = { action: "edit", claim: val };
      editId.value = val.id;
    };

    // handle edit
    const handleDelete = (val) => {
      claim.value = { action: "delete", claim: val };
    };

    // handle remove (passed as props)
    const handleReviewDiagnosis = () => {
      resetDiagnosis.value = true;
    };

    // handle next
    const handleNext = (val) => {
      next.value = val;
    };

    // handle clear (emiited)
    const handleClear = (val) => {
      if (val.id == "resetDiagnosis") {
        resetDiagnosis.value = val.value;
      } else if (val.id == "claim") {
        claim.value = val.value;
      } else if (val.id == "next") {
        next.value = val.value;
      } else if (val.id == "editId") {
        editId.value = val.value;
      }
    };

    // hanlde restart
    const handleRestart = () => {
      context.emit("restart", null);
    };

    // confirmation
    const handleConfirm = (val) => {
      // call submit if confirmed
      if (val) {
        handleSubmit();
      }
    }

    // confirmation
    const handleConfirmEncounterOnly = (val) => {
      // call submit if confirmed
      if (val && selectedProvider.value?.search) {
        // close auth
        openAuth.value = false;
        // Set provider
        response.value.provider_id = selectedProvider.value.search;
        // submit
        handleSubmit();
      }
    }

    // handle final submit
    const handleSubmit = async () => {
      // clear error
      error.value = false;

      // start
      isSubmitting.value = true;

      // add encounter date
      response.value.encounter_date = props.serverDate; // (goes into encounter)

      // setup encounter
      let diagnosis = diagnosisList.value?.join(", ");
      let keysToRemove = ["id", "scheme", "created_at", "updated_at"];
      let newEncounter = {
        ...Object.fromEntries(
          Object.entries(encounter.value).filter(
            ([key]) => !keysToRemove.includes(key)
          )
        ),
      };
      newEncounter = {
        ...newEncounter,
        encounter_cluster_id: null,
        diagnosis: diagnosis,
        user_id: siloMode ? store.state.user?.id : 0, // from easyHMO
      };

      // setup claims
      let newClaims = [];
      let newAuth = ABBR;

      claims.value.forEach((x, y) => {
        newAuth = `${newAuth}-HMO-${Date.now() + y}`;
        newClaims.push({
          encounter_id: null,
          item: x.claim,
          sent_qty: x.qty,
          sent_price: x.amt,
          approved_qty: x.qty,
          approved_price: x.amt,
          standard_price: x.standard,
          authorization: "y",
          authorization_code: newAuth,
        });
      });

      // put all together
      let newVal = { encounter: newEncounter, claims: newClaims };
      // set final endPoint
      let finalEndPoint = siloMode ? endPoint.value : `${endPoint.value}/${OPID}/${selectedProvider.value?.opid}`;

      // post item
      const { res } = await postItem(finalEndPoint, newVal);

      if (res.value) {

        if (res.value.status) {

          // final end
          router.push({
            name: "auth",
            query: {
              encounterId: res.value.data.id,
              created: 1,
            },
          });

        } else {
          // claims month has closed
          error.value = "Bills for enrollee Month has been submitted!";
          isSubmitting.value = false; // end

          // reset on fail
          resetScrollBar();
        }

      } else {

        // manage errors
        error.value = "Sorry, something went wrong!";
        isSubmitting.value = false; // end

        // reset on fail
        resetScrollBar();

      }
    };

    // output encounter results
    const encounter = computed(() => {
      if (!response.value) {
        return null;
      } else {
        return response.value;
      }
    });

    // output claims results
    const claims = computed(() => {
      if (!claimsList.value) {
        return [];
      } else {
        return claimsList.value;
      }
    });

    return {
      showAgeSex,
      handleProvider,
      handleEdit,
      handleReviewDiagnosis,
      handleDelete,
      handleUpdate,
      handleNext,
      handleRestart,
      handleConfirm,
      handleConfirmEncounterOnly,
      handleSubmit,
      handleClear,
      handleSearch,
      handlePick,
      alertTitle,
      alertMessage,
      alertMessageEncounterOnly,
      selectedItem,
      filterProviderData,
      selectedProvider,
      totalSent,
      isReady,
      isLoading,
      isSubmitting,
      error,
      editId,
      claimsDisplayCard,
      claimsSubmitCard,
      resetDiagnosis,
      diagnosisList,
      editClaim,
      deleteClaim,
      encounter,
      claimsList,
      hideUnFound,
      next,
      type,
      claim,
      claims,
      openAuth,
      siloMode: siloMode,
    };
  },
};
</script>

<style scoped>
.auth-enrollee-shell {
  margin-top: 16px;
  width: 100%;
}

.auth-enrollee-workbench {
  width: 100%;
}

.auth-enrollee-card,
.auth-provider-workflow,
.auth-provider-summary,
.auth-provider-panel,
.auth-diagnosis-card,
.auth-claims-card,
.auth-history-shell,
.auth-no-encounter {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.auth-enrollee-section {
  margin: 0;
  padding: 0;
  width: 100%;
}

.auth-enrollee-card,
.auth-provider-workflow {
  background: #ffffff !important;
  background-color: #ffffff !important;
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: none;
  overflow: visible;
  width: 100%;
}

.auth-enrollee-card {
  box-shadow: none;
  margin: 0;
}

.auth-scheme-badge {
  background: #455a64 !important;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 700;
  margin-left: 20px;
}

.auth-enrollee-dossier {
  background: #ffffff;
  border-bottom: 1px solid #c4d3d9;
  padding: 22px 24px !important;
}

.auth-enrollee-dossier-grid {
  align-items: center;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 104px;
  gap: 22px;
  margin-bottom: 0;
}

.auth-enrollee-identity {
  min-width: 0;
}

.auth-enrollee-avatar {
  display: flex;
  justify-content: flex-end;
  min-width: 86px;
}

.auth-enrollee-dossier p {
  color: #607d8b;
  font-weight: 600;
  margin: 0 0 8px;
}

.auth-enrollee-dossier h5 {
  color: #263238;
  font-size: 1.38rem;
  font-weight: 650;
  line-height: 1.18;
  margin: 0;
  max-width: 720px;
  overflow-wrap: anywhere;
}

.auth-enrollee-dossier h6 {
  color: #546e7a;
  font-size: 0.94rem;
  font-weight: 650;
  margin: 8px 0 0;
  overflow-wrap: anywhere;
}

.auth-enrollee-dossier img {
  display: block;
  height: 78px;
  object-fit: cover;
  opacity: 0.86;
  width: 78px;
}

.auth-provider-workflow {
  border: 0;
  border-radius: 0;
  margin: 0;
  padding: 0;
}

.auth-provider-summary {
  background: #f4f6f7 !important;
  background-color: #f4f6f7 !important;
  border-bottom: 1px solid #c4d3d9;
  border-top: 1px solid #c4d3d9;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  padding: 20px 24px !important;
}

.auth-provider-summary .card-title {
  color: #263238;
  font-size: 1.05rem;
  font-weight: 700;
}

.auth-provider-summary h6 {
  color: #00897b !important;
  font-size: 0.9rem;
  font-weight: 700;
  margin: 6px 0 0;
}

.auth-provider-panel {
  background: #e1f2f3 !important;
  border: 0;
  border-bottom: 1px solid #c4d3d9;
  border-radius: 0;
  box-shadow: none;
  margin: 0;
  padding: 22px 24px;
}

.auth-provider-workflow :deep(> .card) {
  background: #e1f2f3 !important;
  background-color: #e1f2f3 !important;
  border-radius: 0;
  border-top: 1px solid #c4d3d9;
  box-shadow: none;
  margin: 18px 0 0;
  width: 100%;
}

.auth-diagnosis-row + :deep(> .card) {
  margin-top: 22px;
}

.auth-provider-workflow :deep(> .card > .card-content) {
  padding: 30px 30px 34px !important;
}

.auth-provider-panel .card-title {
  color: #263238 !important;
  font-size: 1.04rem;
  font-weight: 700;
}

.auth-provider-panel :deep(nav),
.auth-provider-panel :deep(.nav-wrapper) {
  background: transparent !important;
  border: 0;
  border-radius: 0;
  box-shadow: none !important;
}

.auth-provider-panel .btn-large {
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
}

.auth-modal-host {
  height: 0;
  overflow: visible;
  position: relative;
  width: 100%;
}

.auth-diagnosis-row {
  background: transparent !important;
  margin: 22px 0 0;
}

.auth-diagnosis-row .col {
  padding: 0 !important;
}

.auth-diagnosis-card {
  background: #fff9df !important;
  border: 1px solid #f3e4a3;
  border-radius: 0;
  box-sizing: border-box;
  box-shadow: 0 10px 22px -22px rgba(121, 85, 72, 0.6);
  margin: 0;
  padding: 14px 16px !important;
  width: 100%;
}

.auth-diagnosis-card p {
  color: #4e342e;
  font-weight: 650;
  line-height: 1.45;
  margin: 0;
}

.auth-claims-card {
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: none;
  margin: 18px 30px 0;
  width: calc(100% - 60px);
}

.auth-claims-card .card-title {
  color: #263238;
  font-size: 1.05rem;
  font-weight: 700;
}

.auth-claims-card .collection {
  border-color: #e1e8eb;
  border-radius: 6px;
  overflow: hidden;
}

.auth-claims-card .collection-item {
  border-bottom-color: #edf2f4;
  line-height: 1.45;
}

.auth-claims-card .auth-line-item {
  box-sizing: border-box;
  min-height: 54px;
  padding-right: 126px;
  position: relative;
}

.auth-claims-card .auth-line-copy {
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: break-word;
}

.auth-claims-card .line-item-actions {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.auth-claims-card .line-item-actions .secondary-content {
  float: none;
  margin-left: 0;
  position: static;
}

.auth-claims-card .line-item-actions a {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  position: relative;
  width: 30px;
}

.auth-claims-card .line-item-actions a + a::before {
  background: #c4d3d9;
  content: "";
  height: 20px;
  left: -3px;
  position: absolute;
  top: 5px;
  width: 1px;
}

.auth-claims-card .line-item-actions i {
  line-height: 1;
}

.auth-claims-card .btn-large {
  border-radius: 6px;
  box-shadow: none;
  font-weight: 700;
}

.auth-submit-progress {
  border-radius: 0;
  height: 3px;
  margin: 0;
}

.auth-history-shell {
  background: transparent;
  border-top: 0;
  margin-top: 20px;
  padding: 0;
}

.auth-no-encounter {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  color: #607d8b;
  margin-top: 16px;
  padding: 30px;
}

.progress {
  margin-top: -15px;
}

.progress.auth-submit-progress {
  margin: 0;
}

.spacer5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

.spacerTop10 {
  padding-top: 10px;
  padding-bottom: 0px;
}

.edit-black-item:hover .material-icons.black-text,
.edit-black-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
  color: rgb(21, 21, 206) !important;
}

.cancel-item:hover .material-icons.grey-text,
.cancel-item:hover .material-icons.grey-text::before {
  color: rgb(214, 16, 16) !important;
}

@media only screen and (max-width: 992px) {
  .auth-claims-card .auth-line-item {
    padding-right: 20px;
  }

  .auth-claims-card .line-item-actions {
    background: #f8fafb;
    border: 1px solid #dbe5e9;
    border-radius: 999px;
    box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
    gap: 10px;
    margin-top: 10px;
    padding: 4px;
    position: static;
    transform: none;
    width: max-content;
  }

  .auth-claims-card .line-item-actions a {
    height: 34px;
    width: 34px;
  }

  .auth-claims-card .line-item-actions a + a::before {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .auth-enrollee-card,
  .auth-provider-workflow,
  .auth-provider-summary,
  .auth-provider-panel,
  .auth-diagnosis-card,
  .auth-claims-card,
  .auth-history-shell,
  .auth-no-encounter {
    animation: none;
  }
}
</style>

<style>
#confirmSubmitEncounterOnly.auth-confirm-modal,
#confirmSubmit.auth-confirm-modal {
  background: #ffffff;
  border: 1px solid #dbe5e9;
  border-radius: 6px;
  box-shadow: 0 24px 56px rgba(25, 35, 42, 0.34);
  max-height: 72%;
  position: fixed !important;
  top: 24% !important;
  z-index: 10050 !important;
}

.modal-overlay {
  background: rgba(20, 31, 38, 0.62) !important;
  z-index: 10040 !important;
}

</style>
